import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper
} from '@mui/material';

function RenderAssetTable({ assets }) {
  return (
    <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow sx={{ backgroundColor: '#006ee6' }}>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Name</TableCell>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Team</TableCell>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Position</TableCell>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Salary</TableCell>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Projection</TableCell>
            <TableCell sx={{ color: 'white', fontSize: '17px' }}>Usage</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {assets.map((row, index) => (
            <TableRow key={index}>
              <TableCell sx={{ fontSize: '17px' }}>{row.name}</TableCell>
              <TableCell sx={{ fontSize: '17px' }}>{row.team}</TableCell>
              <TableCell sx={{ fontSize: '17px' }}>{row.position}</TableCell>
              <TableCell sx={{ fontSize: '17px' }}>{row.currentCost}</TableCell>
              <TableCell sx={{ fontSize: '17px' }}>{row.dkPoints}</TableCell>
              <TableCell sx={{ fontSize: '17px' }}>{row.ccUsage}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default RenderAssetTable;
